// extracted by mini-css-extract-plugin
export default {"heading":"OrganizationTextBlockEditTemplate_heading__21Apm","buttonLink":"OrganizationTextBlockEditTemplate_buttonLink__+xRas"};